<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <div class="bg-white flex-box col fill" id="print_area">
                <div class="flex-box-bd"></div>
                <div class="flex-box">
                    <div class="flex-box-bd"></div>
                    <div><vue-qr :logoSrc="code_url_logo" :text="code_url" :size="350"></vue-qr></div>
                    <div class="flex-box-bd"></div>
                </div>
                <div class="f40 f-blue mg-top40 fillw tcenter">扫描进入小程序</div>
                <div class="flex-box-bd"></div>
                <div class="flex-box-bd"></div>
                <div class="pd-10 f-blue f20 fillw tcenter">{{org_cname}}</div>
            </div>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" v-print="printObj">{{$t('print')}}</Button>
        </div>
    </div>
</template>

<script>
    import vueQr from 'vue-qr'
    export default {
        components:{
            vueQr
        },
        data:function(){
            return{
                org_cname:'',
                code_url:'',//支付二维码
                code_url_logo: require("@/assets/img/logo.png"),

                printObj:{
                    id:'#print_area',
                    popTitle: '-',
                    endCallback(){}
                }
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var info = this.$base.getRequest();
            this.code_url = this.$config.wxmpUrl+'?org_id='+info.org_id;
            this.org_cname = info.org_cname;
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>
.lineh{
    height: 4vh;
    line-height: 4vh;
}
.top-line{
    border-top:solid 1px #333;
}
</style>



// WEBPACK FOOTER //
// src/pages/org/ewm/wxmp.vue